module.exports = __webpack_public_path__ + "static/media/6.Oil Starter & Star Delta.4e96d18e.jpg";